import { ecsApi } from '@services';
import { FavoriteOrderCreatePayload, FavoriteOrderCreateResponse, GetFavoriteOrdersResponse } from './favoriteOrders.types';

export const favoriteOrdersApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        getFavoriteOrders: builder.mutation<GetFavoriteOrdersResponse, undefined>({
            query: () => ({
                url: '/orders/favorites',
                method: 'GET'
            })
        }),
        createFavoriteOrder: builder.mutation<FavoriteOrderCreateResponse, FavoriteOrderCreatePayload>({
            query: (payload) => ({
                url: '/orders/favorites',
                method: 'POST',
                body: payload
            })
        })
    })
});

export const { useGetFavoriteOrdersMutation, useCreateFavoriteOrderMutation } = favoriteOrdersApi;
